// possible locations where we can add an item in relation to the selected item
// returned by Gardener.getAddType
const CHILD = 'child', SIBLING = 'sibling', ROOT = 'root'

export { CHILD, SIBLING, ROOT }
